
import { useEffect, useState } from 'react'

import { Button, Icon, Select, Table } from 'semantic-ui-react'

import { DropdownOptions } from '../../constants'

import { AgencyCreateForm, LoadingSpinner, ErrorMessage, NoData } from '../../components'

import { Agency } from '../../models'

import { AgencyService, HelperService } from '../../services'


export function SupervisorAgenciesPage() {

    const [agencies, setAgencies] = useState<Agency[]>([])
    const [loadingAgencies, setLoadingAgencies] = useState<boolean>(true)
    const [errorFetchingAgencies, setErrorFetchingAgencies] = useState<boolean>(false)
    const [createModalVisible, setCreateModalVisible] = useState(false)


    useEffect(() => {

        AgencyService.getAgenciesList('sup')
            .then(data => {
                console.log(data)
                setAgencies(data)

            })
            .catch(err => setErrorFetchingAgencies(true))
            .finally(() => setLoadingAgencies(false))

    }, [])


    const addAgencyToList = (agency: Agency) => {

        setAgencies([agency, ...agencies])

        HelperService.storeAgencies([agency, ...agencies])

    }


    return <div>

        {errorFetchingAgencies && <ErrorMessage />}

        {loadingAgencies && <LoadingSpinner />}

        {!loadingAgencies && !errorFetchingAgencies &&
            <>
                <div className='headerRow'>
                    <div className='flex-center'>
                        {agencies.length > 0 && <Select className='mr-25' placeholder='Filtrer par région' options={DropdownOptions.regionOptions} />}
                        {agencies.length > 0 && <Select className='mr-25' placeholder='Filtrer par département' options={DropdownOptions.departementsOptions} />}
                    </div>
                    <Button color='orange' className='size-16' onClick={() => setCreateModalVisible(true)}><Icon name="add circle" />Créer une agence</Button>
                </div>

                {
                    agencies.length === 0 ? <NoData /> :

                        <Table basic='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Nom</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Nombre de caisse</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Date de création</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Ville</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Département</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17"></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>

                                {agencies.map(ag =>
                                    <Table.Row key={ag.id}>
                                        <Table.Cell>{ag.id}</Table.Cell>
                                        <Table.Cell>{ag.name}</Table.Cell>
                                        <Table.Cell>{ag.tillsCount}</Table.Cell>
                                        <Table.Cell> {ag.createdAt?.toLocaleString()}</Table.Cell>
                                        <Table.Cell> {ag.area?.city}</Table.Cell>
                                        <Table.Cell> {ag.area?.department}</Table.Cell>
                                        <Table.Cell textAlign='right'>

                                            <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                            <Button className='mr-10'>Plus</Button>
                                            <Button className='mr-10'><Icon name='pencil alternate' /> Éditer</Button>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                }

            </>
        }

        {createModalVisible && <AgencyCreateForm setCreateModalVisible={setCreateModalVisible} addAgencyToList={addAgencyToList} />}

    </div>
}